import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "src/@/components/ui/dialog";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { useEffect, useState } from "react";
import actionListaRespostasRapida from "src/actions/dashboard/respostas-rapidas/actionListaRespostasRapida";
import useAuth from "src/hooks/useAuth";
import Iconify from "src/components/Iconify";

export default function ModalMensagensRapidasAutomacoes({

  onSelect,
}) {
  const [filtroTipo, setFiltroTipo] = useState("todos");
  const {user} = useAuth();
    const [listaRespostasRapidas, setListaRespostasRapidas] = useState([]);
    const [pesquisaRespostaRapida, setPesquisaRespostaRapida] = useState("");
    const [open, setOpen] = useState(false);

  function validaTipo(type) {
    if (type === "texto") {
      return <span className="text-lg">📝</span>;
    } else if (type === "arquivo") {
      return <span className="text-lg">📁</span>;
    } else if (type === "audio") {
      return <span className="text-lg">🎤</span>;
    }
  }

  const filtrarMensagens = () => {
    return listaRespostasRapidas.filter((item) => item.tipo === "texto");
  };

  const buscarListaResponstasRapidas = async () => {
    try {
        const res = await actionListaRespostasRapida(user.clienteId, user.id);
        setListaRespostasRapidas(res.data.respostas);
    } catch (error) {
        console.log('error', error)
    }
}

useEffect(() => {
    buscarListaResponstasRapidas();
}
, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger>
            <Button variant="secondary" className="text-xs">
             <Iconify color="primary" icon="mdi:message-text-fast" />
                Mensagens Rápidas
                </Button>
        </DialogTrigger>
      <DialogContent className="max-w-lg min-w-lg">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">Mensagens Rápidas</DialogTitle>
        </DialogHeader>
        <div className="p-4 space-y-4">
          {/* Campo de Pesquisa */}
          <div>
            <Input
              value={pesquisaRespostaRapida}
              onChange={e => setPesquisaRespostaRapida(e.target.value)}
              placeholder="Pesquisar"
              className="w-full"
            />
          </div>
        
          {/* Lista de Mensagens com Scroll */}
          <div
            className="space-y-2 overflow-y-auto"
            style={{ height: "400px" }} // Altura aumentada para 600px
          >
            {filtrarMensagens().map((item, index) => (
              <div
                key={index}
                className="p-4 bg-gray-100 rounded-lg cursor-pointer hover:bg-gray-200"
                onClick={() => {
                    onSelect(item.resposta);
                    setOpen(!open);
                }}
              >
                <div className="flex items-start space-x-3">
                  <div>{validaTipo(item.tipo)}</div>
                  <div>
                    <p className="text-sm font-medium">{item.titulo}</p>
                    <p className="text-xs text-gray-600">{item.resposta}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
